export default __webpack_public_path__ + "static/media/mysql.ed4d0eff.png";